import styled from "styled-components";
export const AirplaneWrapper = styled.div`
  background-color: #fff;
`;
